import { OPItem } from "@/interfaces/CardItem";

var hypergeometric = require("@stdlib/stats-base-dists-hypergeometric");

export function formatPercentage(num: number) {
  const percent = (num * 100).toFixed(1);
  return `${percent}%`;
}

export interface Card {
  id: string;
  count: number;
  data: any; // Changed from OPItem to any to support all card types
}

export function searcherProbability(
  hits: number,
  cardsToSearch: number,
): number {
  const cardsInDeck = 50;
  return 1 - hypergeometric.pmf(0, cardsInDeck, hits, cardsToSearch);
}
